const modules = {
    // Client contract
    client_contract_listing: {
        session: "Client contract",
        module: "Listing",
    },
    contractinfo: {
        session: "Client contract",
        module: "Info",
    },
    sor: {
        session: "Client contract",
        module: "SOR",
    },
    service_category: {
        session: "Client contract",
        module: "Service Category"
    },
    sla: {
        session: "Client contract",
        module: "SLA"
    },
    properties: {
        session: "Client contract",
        module: "Property"
    },
    equipment: {
        session: "Client contract",
        module: "Equipment"
    },
    checklist_template: {
        session: "Client contract",
        module: "Checklist Template"
    },
    fm_officer: {
        session: "Client contract",
        module: "FM Officer"
    },
    client_contract_program: {
        session: "Client contract",
        module: "Maintenance Program"
    },
    client_contract_staff: {
        session: "Client contract",
        module: "Client Staff"
    },
    approval: {
        session: "Client contract",
        module: "Approval Route"
    },
    client_contract_finance: {
        session: "Client contract",
        module: "Finance"
    },
    //supplier Contract
    supplier_contract_info: {
        session: "Supplier Contract",
        module: "Info",
    },
    supplier_contract_listing: {
        session: "Supplier Contract",
        module: "Listing",
    },
    supplier_contract_service_category: {
        session: "Supplier Contract",
        module: "Service Category",
    },
    supplier_contract_property: {
        session: "Supplier Contract",
        module: "Properties",
    },
    supplier_contract_equipment: {
        session: "Supplier Contract",
        module: "Equipment",
    },
    supplier_contract_sor: {
        session: "Supplier Contract",
        module: "SOR",
    },
    supplier_contract_program: {
        session: "Supplier Contract",
        module: "Maintenance Program",
    },
    supplier_contract_staff: {
        session: "Supplier Contract",
        module: "Supplier Staff",
    },
    //Work Order
    order: {
        session: "Work Order",
        module: "All Order",
    },
    allow_wo_invoiced: {
        session: "Work Order",
        module: "Allow Completed to Invoiced"
    },
    wo_create_activity_log: {
        session: "Work Order",
        module: "Create Manual Activity Log"
    },
    //Preventive Maintenance
    maintenance_program: {
        session: "Preventive Maintenance",
        module: "Program"
    },
    job_list: {
        session: "Preventive Maintenance",
        module: "Job List"
    },
    issue_register: {
        session: "Preventive Maintenance",
        module: "Issue Register"
    },
    job_spe: {
        session: "Preventive Maintenance",
        module: "Endorse The Job / Checklist"
    },
    parts_replacement: {
        session: "Preventive Maintenance",
        module: "Parts Replacement"
    },
    joblist_soft_fm: {
        session: "Preventive Maintenance",
        module: "Job List - Soft FM"
    },
    old_case_management: {
        session: "Old Case Management",
        module: "Old Case"
    },
    email_management:{
        session: "Email Management",
        module: "Email List"
    },
    maintenance_schedule: {
        session: "Preventive Maintenance",
        module: "Maintenance Schedule"
    },
    lift_inspection_scheduling: {
        session: "Preventive Maintenance",
        module: "Lift Inspection Scheduling"
    },
    allow_to_verify_job: {
        session: "Preventive Maintenance",
        module: "Allow to verify job"
    },
    allow_editing_job_completed: {
        session: "Preventive Maintenance",
        module: "Allow editing Job Completed"
    },
    allow_editing_job_verified: {
        session: "Preventive Maintenance",
        module: "Allow editing Job Verified"
    },
    // Case
    case_management: {
        session: "Case Management",
        module: "Case"
    },
    case_management_cancel: {
        session: "Case Management",
        module: "Cancel a case"
    },
    // Finance
    ap_raise_pv: {
        session: "Finance",
        module: "Raise PV"
    },
    general_ledger: {
        session: "Finance",
        module: "General Ledger"
    },
    posting_rules: {
        session: "Finance",
        module: "Posting Rules"
    },
    navision_file_listing: {
        session: "Finance",
        module: "Navision File Listing"
    },
    navision_file_config: {
        session: "Finance",
        module: "Navision File Config"
    },
    ap_invoice: {
        session: "Finance",
        module: "AP Invoice"
    },
    payment_voucher: {
        session: "Finance",
        module: "Payment Voucher"
    },
    chart_of_account: {
        session: "Finance",
        module: "Chart Of Account"
    },
    misc_expenses: {
        session: "Finance",
        module: "Misc Expenses"
    },
    liquidated_damages: {
        session: "Finance",
        module: "Liquidated Damages"
    },
    // Account
    companies: {
        session: "Accounts",
        module: "Companies"
    },
    users: {
        session: "Accounts",
        module: "Users"
    },
    show_tab_all_users: {
        session: "Accounts",
        module: "Show tab All Users"
    },
    allow_modifying_other_user_mfa: {
        session: "Accounts",
        module: "Allow modifying other user MFA"
    },
    roles: {
        session: "Accounts",
        module: "Role and Authorisation"
    },
    audit_trail: {
        session: "Accounts",
        module: "Audit Trails"
    },
    user_duty: {
        session: "Accounts",
        module: "User Duty"
    },
    password_management: {
        session: "Accounts",
        module: "Password Management"
    },
    users_access_report: {
        session: "Accounts",
        module: "User Access Report"
    },
    //Utilities
    water_meter_listing: {
        session: "Utilities",
        module: "Water Meters" //Meter Listing
    },
    water_reading_log: {
        session: "Utilities",
        module: "Water Reading Logs" //Reading Log
    },
    electricity_meter_listing: {
        session: "Utilities",
        module: "Electricity Meters"
    },
    electricity_reading_log: {
        session: "Utilities",
        module: "Electricity Reading Logs"
    },


    //Master Table
    service_category_master: {
        session: "Master Table",
        module: "Service Categories Master"
    },

    checklist_template_master: {
        session: "Master Table",
        module: "Checklist Template Master"
    },

    maintenance_standard: {
        session: "Master Table",
        module: "Maintenance Standard"
    },
    tax_and_versioning: {
        session: "Master Table",
        module: "Tax And Versioning"
    },
    vendor_linking: {
        session: "Master Table",
        module: "Vendor Linking"
    },
    approval_template: {
        session: "Master Table",
        module: "Approval Templates"
    },
    tenant_site: {
        session: "Master Table",
        module: "Tenant Sites"
    },
    master_notification_template: {
        session: "Master Table",
        module: "Master Notification Template"
    },
    master_notification_event_trigger: {
        session: "Master Table",
        module: "Notification - Event Trigger"
    },
    master_notification_parameter: {
        session: "Master Table",
        module: "Notification - Parameters"
    },
    master_case_requestor_type: {
        session: "Master Table",
        module: "Master Case Requestor Type"
    },
    master_brands: {
        session: "Master Table",
        module: "Master Brands"
    },
    master_equipment_structure: {
        session: "Master Table",
        module: "Equipment Structure"
    },
    resident_site: {
        session: "Master Table",
        module: "Resident Sites"
    },


    //Developer
    all_companies: {
        session: "Developer",
        module: "All Companies"
    },
    master_priority_set: {
        session: "Developer",
        module: "Master Priority Set"
    },
    time_bracket: {
        session: "Developer",
        module: "Time Bracket"
    },
    app_version: {
        session: "Developer",
        module: "App Version"
    },

    //Order tabs
    order_tabs: {
        main_info: {
            session: "Work Order",
            module: "Main Info"
        },
        kpi_target: {
            session: "Work Order",
            module: "KPI Target"
        },
        service_report: {
            session: "Work Order",
            module: "Service Report"
        },
        related_work_items: {
            session: "Work Order",
            module: "Related Work Items"
        },
        delivery_log: {
            session: "Work Order",
            module: "Delivery Log"
        },
        budget: {
            session: "Work Order",
            module: "Budget"
        },
        activity_log: {
            session: "Work Order",
            module: "Activity Log"
        },
        work_findings: {
            session: "Work Order",
            module: "Work Findings"
        },
    },
    work_order_to_paid: {
        session: "Work Order",
        module: "WO to Paid"
    },
    allow_supplier_to_create_wo: {
        session: "Finance",
        module: "Allow Supplier to create WO"
    },
    allow_supplier_to_add_delivery_order: {
        session: "Finance",
        module: "Allow Supplier to add Delivery Order"
    },

    //Setting System
    reference_table: {
        session: "System Config",
        module: "Reference Table"
    },
    web_column_setting: {
        session: "System Config",
        module: "Web Column Setting"
    },
    table_purging: {
        session: "System Config",
        module: "Table Purging"
    },
    mobile_app_versioning: {
        session: "System Config",
        module: "Mobile App Versioning"
    },
    operating_hours: {
        session: "System Config",
        module: "Operating hours"
    },
    navision_cronjob_setting: {
        session: "System Config",
        module: "Navision Cronjob Setting"
    },
    app_token: {
        session: "System Config",
        module: "App Token"
    },
    mapping_report: {
        session: "System Config",
        module: "Mapping Report"
    },
    can_view_lmu_adhoc_menu: {
        session: "LMU Adhoc",
        module: "Can View LMU Adhoc Menu"
    },
    incoming_documents: {
        session: "LMU Adhoc",
        module: "Incoming Documents"
    },
    allow_accept_incoming: {
        session: "LMU Adhoc",
        module: "Allow accept incoming"
    },
    allow_reject_incoming: {
        session: "LMU Adhoc",
        module: "Allow reject incoming"
    },
    allow_endorse_incoming: {
        session: "LMU Adhoc",
        module: "Allow endorse incoming"
    },
    // NLT
    amend_closed_case_details: {
        session: "Case Management",
        module: "Amend Closed Case Details"
    },
    amend_closed_case_activity: {
        session: "Case Management",
        module: "Amend Closed Case Activity"
    },
    approval_request: {
        session: "LMU Adhoc",
        module: "Approval Request"
    },
    import_logs: {
        session: "Accounts",
        module: "Import Logs"
    },
    // Order
    wo_the_read_only: {
        session: "Work Order",
        module: "WO The Read Only"
    },
    // Audit Trail
    allow_can_view_audit_trail_duty_assignment: {
        session: "Audit Trail",
        module: "Duty Assignment"
    },
    allow_can_view_audit_trail_role_setup: {
        session: "Audit Trail",
        module: "Role Setup"
    },
    allow_can_view_audit_trail_user_activities: {
        session: "Audit Trail",
        module: "User Activities"
    },
    allow_can_view_audit_trail_user_info: {
        session: "Audit Trail",
        module: "User Info"
    },
    // UOB Integration
    uob_generate_qr: {
        session: "UOB Integration",
        module: "Generate QR Code"
    },
    uob_notifications: {
        session: "UOB Integration",
        module: "Notifications"
    },
    uob_transactions: {
        session: "UOB Integration",
        module: "Transactions"
    },
    nlt_property: {
        session: "Case Management",
        module: "NLT Property"
    },
    change_hot_button_case_status: {
        session: "Case Management",
        module: "Change Hot Button Case Status"
    },
    // 	EME Safety App
    safety_inspection_checklist: {
        session: "EME Safety App",
        module: "Safety Inspection Checklist"
    },
    permit_to_work: {
        session: "EME Safety App",
        module: "Permit To Work"
    },
    non_conformance_report: {
        session: "EME Safety App",
        module: "Non Conformance Report"
    },
    toolbox_meeting: {
        session: "EME Safety App",
        module: "Toolbox Meeting"
    },
    safety_induction_training: {
        session: "EME Safety App",
        module: "Safety Induction Training"
    },
    safety_app_workers: {
        session: "Safety App Administrator",
        module: "Workers"
    },
    safety_app_location: {
        session: "Safety App Administrator",
        module: "Location"
    },
    safety_app_project: {
        session: "Safety App Administrator",
        module: "Project"
    },
    safety_app_subcontractor: {
        session: "Safety App Administrator",
        module: "Subcontractor"
    },
    safety_app_users: {
        session: "Safety App Administrator",
        module: "Users"
    },
}
export { modules }